import * as React from "react";
import { Routes, Route } from "react-router-dom";
import { SnipAnalysisListScreen } from "./SnipAnalysisListScreen";
import { SnipSessionsListScreen } from "./SnipSessionsListScreen";
import { SnipAnalysisScreen } from "./SnipAnalysisScreen";
import { PrivateRoute } from "../../../Core/PrivateRoute";
import { PermissionEnum } from "../../../misc/api/ApiPermissionEnum";

export const SnipRoot = () => {
    return (
        <Routes>
            <Route index
                element={
               <PrivateRoute permissions={[PermissionEnum.AccessSingleSnipSession, PermissionEnum.AccessAllSnipSessions, PermissionEnum.OverreadSnipSession]}>
                <SnipSessionsListScreen />
                    </PrivateRoute>
                }
            />
            <Route path="Analysis" element={
               <PrivateRoute permissions={[PermissionEnum.OverreadSnipSession]}>
                <SnipAnalysisListScreen />
                 </PrivateRoute>
                }
            />
            <Route path="Analysis/:analysisSetId/:viewState" element={
                <PrivateRoute permissions={[PermissionEnum.OverreadSnipSession, PermissionEnum.AccessSingleSnipSession]}>
                <SnipAnalysisScreen />
                </PrivateRoute>
            }
            />
        </Routes>
    );
}
